var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDataImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 130,
    viewBox: "0 0 184 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 63.5C34 98.0178 61.9822 126 96.5 126C131.018 126 159 98.0178 159 63.5C159 28.9822 131.018 1 96.5 1C61.9822 1 34 28.9822 34 63.5Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.5C0 64.4036 5.59644 70 12.5 70C19.4036 70 25 64.4036 25 57.5C25 50.5964 19.4036 45 12.5 45C5.59644 45 0 50.5964 0 57.5Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5C20 20.1944 23.8056 24 28.5 24C33.1944 24 37 20.1944 37 15.5C37 10.8056 33.1944 7 28.5 7C23.8056 7 20 10.8056 20 15.5Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 89C170 92.866 173.134 96 177 96C180.866 96 184 92.866 184 89C184 85.134 180.866 82 177 82C173.134 82 170 85.134 170 89Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.816 86.3132L92.3945 75.3953L100.134 64.5215C100.658 63.7621 101.628 63.4209 102.52 63.696L131.849 72.6328C133.21 73.0511 133.779 74.6359 132.987 75.8026L125.816 86.3132Z",
    fill: "url(#paint0_linear_22841_184158)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3945 75.3945L92.573 97.0542L125.816 86.3124L92.3945 75.3945Z",
    fill: "url(#paint1_linear_22841_184158)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.008 86.3672L124.803 118.163C124.803 119.088 124.19 119.902 123.298 120.177L92.5859 129.499V97.054L126.008 86.3672Z",
    fill: "url(#paint2_linear_22841_184158)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.817 86.3125L133.567 97.5055C134.493 98.8483 133.869 100.686 132.307 101.204L103.636 110.658C102.566 111.01 101.384 110.603 100.77 109.667L92.5625 97.0653L125.817 86.3125Z",
    fill: "url(#paint3_linear_22841_184158)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5719 97.0516V129.497L62.2168 120.736C60.3099 120.197 59.0163 118.469 59.0274 116.51L59.2616 86.8711L92.5719 97.0516Z",
    fill: "url(#paint4_linear_22841_184158)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5737 97.0516L83.0278 110.49C82.7156 110.941 82.1468 111.128 81.6338 110.952L50.8327 100.739C50.0521 100.474 49.751 99.5389 50.2305 98.8786L59.1296 86.8711L92.5737 97.0516Z",
    fill: "url(#paint5_linear_22841_184158)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3946 75.3945L59.1289 86.8737L92.573 97.0542L92.3946 75.3945Z",
    fill: "url(#paint6_linear_22841_184158)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3971 75.393L84.8362 64.387C84.3009 63.5616 83.2638 63.2094 82.3159 63.5065L53.9905 72.6965C52.6634 73.1257 52.0724 74.6666 52.7972 75.8552L59.4102 86.8171L92.3971 75.393Z",
    fill: "url(#paint7_linear_22841_184158)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7058 82.1309C82.4939 82.1309 82.282 82.0758 82.0813 81.9658C82.0032 81.9217 80.0517 80.7991 77.9552 78.5209C77.4868 78.0146 77.5314 77.2332 78.0444 76.771C78.5574 76.3087 79.3491 76.3527 79.8175 76.859C81.6352 78.8291 83.3303 79.8086 83.3415 79.8196C83.9437 80.1608 84.1444 80.9202 83.7987 81.5145C83.5533 81.9107 83.1296 82.1309 82.7058 82.1309ZM76.0036 74.8779C75.5464 74.8779 75.1115 74.6358 74.8884 74.2066C74.0632 72.6327 73.4722 70.9488 73.1153 69.2209C72.9815 68.5495 73.4164 67.9002 74.0967 67.7571C74.7769 67.625 75.4349 68.0543 75.5798 68.7256C75.8809 70.2334 76.4051 71.6862 77.1188 73.062C77.4422 73.6673 77.1968 74.4157 76.5835 74.7349C76.4051 74.8339 76.2043 74.8779 76.0036 74.8779ZM74.0855 65.2918C74.0186 65.2918 73.9405 65.2808 73.8736 65.2698C73.1934 65.1597 72.725 64.5214 72.8477 63.839C73.1711 61.924 74.1859 60.2841 75.8586 58.9634C76.4051 58.5341 77.1968 58.6222 77.6206 59.1615C78.0555 59.7008 77.9663 60.4712 77.4199 60.9004C76.2266 61.8469 75.5352 62.9365 75.3122 64.2572C75.223 64.8625 74.6877 65.2918 74.0855 65.2918ZM81.1223 58.9744C80.587 58.9744 80.0963 58.6332 79.929 58.1049C79.7171 57.4555 80.0851 56.7512 80.7431 56.553C82.2486 56.0798 83.966 55.7166 85.8617 55.4635C86.5532 55.3754 87.1777 55.8487 87.278 56.531C87.3672 57.2134 86.8877 57.8297 86.1963 57.9288C84.4455 58.1599 82.8619 58.5011 81.5014 58.9193C81.3676 58.9523 81.2449 58.9744 81.1223 58.9744ZM96.0656 57.6206C96.0433 57.6206 96.0098 57.6206 95.9875 57.6206C95.0285 57.5656 93.2554 57.4886 91.0808 57.5546C90.4005 57.5766 89.8095 57.0373 89.7872 56.3549C89.7649 55.6726 90.3113 55.1003 91.0027 55.0783C93.2777 55.0122 95.1288 55.0893 96.1437 55.1553C96.8351 55.1993 97.3592 55.7826 97.3257 56.465C97.2811 57.1033 96.7235 57.6206 96.0656 57.6206ZM100.995 56.7952C100.437 56.7952 99.9241 56.421 99.7791 55.8597C99.6007 55.1993 100.013 54.517 100.682 54.3519C102.411 53.9116 103.928 53.3943 105.199 52.8C105.823 52.5139 106.571 52.778 106.872 53.3943C107.173 54.0107 106.894 54.7481 106.269 55.0452C104.864 55.7056 103.192 56.2779 101.318 56.7512C101.207 56.7842 101.095 56.7952 100.995 56.7952ZM109.782 52.3048C109.492 52.3048 109.202 52.2057 108.968 52.0076C108.444 51.5674 108.377 50.7859 108.834 50.2577C109.726 49.2231 110.161 48.0895 110.161 46.7908C110.161 46.7137 110.161 46.6367 110.161 46.5597C110.139 45.8773 110.674 45.305 111.366 45.272C112.057 45.2389 112.637 45.7782 112.671 46.4606C112.671 46.5707 112.682 46.6807 112.682 46.7908C112.682 48.6838 112.035 50.3897 110.752 51.8755C110.485 52.1617 110.139 52.3048 109.782 52.3048ZM84.9362 46.2075C84.2559 46.2075 83.6983 45.6682 83.676 44.9968C83.676 44.8427 83.6649 44.6886 83.6649 44.5346C83.6649 43.2579 83.8098 42.0692 84.1109 41.0017C84.2894 40.3413 84.9808 39.9561 85.6499 40.1322C86.319 40.3083 86.7093 40.9906 86.5309 41.651C86.2967 42.4985 86.174 43.467 86.174 44.5346C86.174 44.6666 86.174 44.7987 86.1852 44.9308C86.2075 45.6131 85.6499 46.1855 84.9585 46.1965C84.9473 46.2075 84.9362 46.2075 84.9362 46.2075ZM109.916 43.0598C109.47 43.0598 109.046 42.8286 108.812 42.4214C107.931 40.8586 106.816 39.5048 106.024 38.6574C105.556 38.1511 105.6 37.3697 106.113 36.9074C106.626 36.4452 107.418 36.4782 107.886 36.9845C108.767 37.942 110.016 39.4498 111.02 41.2218C111.355 41.8161 111.132 42.5755 110.529 42.9057C110.329 43.0157 110.128 43.0598 109.916 43.0598ZM87.9917 38.4813C87.6237 38.4813 87.2557 38.3162 87.0104 38.008C86.5755 37.4687 86.6758 36.6873 87.2111 36.2691C88.5605 35.2125 90.289 34.4861 92.3409 34.1119C93.0323 33.9909 93.6791 34.4311 93.8018 35.1025C93.9245 35.7738 93.4784 36.4232 92.7981 36.5442C91.1477 36.8414 89.7983 37.4027 88.7724 38.2061C88.5382 38.3932 88.2594 38.4813 87.9917 38.4813ZM102.545 37.0285C102.456 37.0285 102.366 37.0175 102.288 37.0065C100.616 36.6543 99.0097 36.4342 97.493 36.3351C96.8016 36.2911 96.2775 35.7078 96.3221 35.0254C96.3667 34.3431 96.9577 33.8258 97.6491 33.8698C99.2773 33.9689 101.017 34.211 102.801 34.5852C103.482 34.7283 103.916 35.3886 103.771 36.06C103.649 36.6323 103.125 37.0285 102.545 37.0285Z",
    fill: "url(#paint8_linear_22841_184158)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5573 33.1193C68.7878 32.0077 68.799 31.2483 69.5573 30.577C70.2822 29.9386 71.0516 30.0267 72.033 30.8411C73.2708 32.1508 74.4975 33.4605 75.7354 34.7702C76.4937 35.5737 77.252 36.3881 78.0103 37.1915C78.501 37.7308 79.0028 38.2481 79.4712 38.7984C80.0734 39.5138 80.0176 40.3943 79.382 41.0106C78.7352 41.6379 77.8319 41.693 77.1293 41.0766C76.5606 40.5814 76.0588 39.9981 75.5346 39.4588C74.7206 38.6003 73.9176 37.7418 73.1036 36.8834C71.9326 35.6397 70.7394 34.374 69.5573 33.1193Z",
    fill: "url(#paint9_linear_22841_184158)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4512 33.0429C82.9494 31.8873 82.0238 31.1389 80.9086 30.6106C77.9088 29.0147 74.9536 29.1798 72.043 30.8417C73.2808 32.1514 74.5075 33.4611 75.7453 34.7709C76.5037 35.5743 77.262 36.3887 78.0203 37.1922C78.2768 36.95 78.6002 37.0491 78.9124 37.0161C80.0499 36.906 81.1874 36.7959 82.2245 36.2677C83.5962 35.5743 84.0422 34.4077 83.4512 33.0429Z",
    fill: "url(#paint10_linear_22841_184158)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1125 36.8954C71.9304 35.6297 70.7483 34.3751 69.5662 33.1094C69.3209 33.5276 69.0532 33.9238 68.8525 34.353C67.8042 36.6533 67.5143 38.9865 68.5402 41.3748C68.741 42.1563 69.1759 42.8386 69.6554 43.4219C71.094 45.1609 73.4582 45.5791 74.6402 42.9157C75.1309 41.8041 75.2536 40.6154 75.5435 39.4598C74.7295 38.6123 73.9154 37.7539 73.1125 36.8954Z",
    fill: "url(#paint11_linear_22841_184158)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22841_184158",
    x1: 102.617,
    y1: 90.277,
    x2: 117.702,
    y2: 67.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22841_184158",
    x1: 92.3897,
    y1: 86.2248,
    x2: 125.813,
    y2: 86.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22841_184158",
    x1: 111.611,
    y1: 143.275,
    x2: 108.424,
    y2: 93.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22841_184158",
    x1: 102.296,
    y1: 104.547,
    x2: 134.955,
    y2: 86.7125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22841_184158",
    x1: 76.5834,
    y1: 138.585,
    x2: 75.6727,
    y2: 100.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22841_184158",
    x1: 69.229,
    y1: 104.856,
    x2: 76.3099,
    y2: 81.4328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22841_184158",
    x1: 99.9092,
    y1: 86.2248,
    x2: 68.1222,
    y2: 86.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22841_184158",
    x1: 72.5712,
    y1: 80.9147,
    x2: 71.74,
    y2: 42.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22841_184158",
    x1: 93.0927,
    y1: 35.6996,
    x2: 92.6576,
    y2: 61.4841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22841_184158",
    x1: 64.872,
    y1: 27.0618,
    x2: 80.3123,
    y2: 41.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22841_184158",
    x1: 72.0405,
    y1: 33.3467,
    x2: 83.708,
    y2: 33.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22841_184158",
    x1: 67.8908,
    y1: 38.9763,
    x2: 75.5351,
    y2: 38.9763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDataImage);
export default __webpack_public_path__ + "static/media/empty-data-image.72c11161158cf4b9151190fefc3556f3.svg";
export { ForwardRef as ReactComponent };